import { render, staticRenderFns } from "./AppGebruikerEditEmail.vue?vue&type=template&id=2a241408&scoped=true&"
import script from "./AppGebruikerEditEmail.vue?vue&type=script&lang=ts&"
export * from "./AppGebruikerEditEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a241408",
  null
  
)

export default component.exports